import React from 'react';
import styled from 'styled-components';
import TransitionElement from './TransitionElement';


export interface Props {
  timeout: number,
  flipped?: boolean,
  className?: string,
}

const Drawer:React.FC<Props> = ({
  children,
  timeout,
  flipped = false,
  className = '',
}) => {
  return (
    <DrawerOuter
      className={className + (flipped ? ' flipped' : ' not-flipped')}
      timeout={timeout}
    >
      {children}
    </DrawerOuter>
  );
};
export default Drawer;

const DrawerOuter = styled.div<{ timeout: number, }>`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  position: relative;
  width: 100%;
  transition-property: transform;
  transition-duration:  ${(p) => p.timeout}ms;
  transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
  &:first-of-type { order: 1; }
  transform: translateX(-100vw);
  &.flipped { transform: translateX(100vw); }
  ${({ theme }) => theme.breakpoints.up('tablet')} {
    width: 50vw;
    transform: translateX(-50vw);
    &.flipped { transform: translateX(50vw); }
    &:first-of-type { order: 0; }
  }
  &.flipped { text-align: right; }
  ${TransitionElement}.enter & {
    transform: translateX(-50vw);
    ${({ theme }) => theme.breakpoints.up('tablet')} { transform: translateX(-50vw); }
    &.flipped {
      transform: translateX(100vw);
      ${({ theme }) => theme.breakpoints.up('tablet')} { transform: translateX(50vw); }
    }
  }
  ${TransitionElement}.enter-done & {
    transform: translateX(0);
  }
  ${TransitionElement}.exit &,
  ${TransitionElement}.exit-done & {
    transform: translateX(-100vw);
    ${({ theme }) => theme.breakpoints.up('tablet')} { transform: translateX(-50vw); }
    &.flipped {
      transform: translateX(100vw);
      ${({ theme }) => theme.breakpoints.up('tablet')} { transform: translateX(50vw); }
    }
  }
`;
